import { InfoOutlined, MehOutlined, SmileOutlined } from "@ant-design/icons";
import { List, NotificationArgsProps, Typography, notification } from "antd";
import { AxiosError } from "axios";
import { ReactNode } from "react";
import WebHttpErroResponseValidacaoEntity from "../Models/Utils/Error/WebHttpErroResponseValidacao";
import WebHttpErroResponse from "../Models/Utils/Error/WebHttpErroResponse";

export const PropriedadesDeNotificacao = {
    Sucesso: (mensagem) => ({
        message: mensagem,
        icon: <SmileOutlined style={{ color: 'green' }} />,
        placement: 'topRight'
    }),

    Erro: (mensagem) => ({
        message: mensagem,
        icon: <MehOutlined style={{ color: 'red' }} />,
        placement: 'topRight'
    }),
    
    Aviso : (mensagem) => ({
        message: mensagem,
        icon: <InfoOutlined style={{ color: 'blue' }} />,
        placement: 'topRight'
    })
} satisfies { 
    [key: string] : (mensagem: NotificationArgsProps["message"]) => NotificationArgsProps 
} 

export const notificarErroNaRequisicao = (err: AxiosError) => {
    const CaminhoDaRequisicao = () => <> {err.response?.config.method?.toUpperCase()} <a>{((err.config?.baseURL ?? '') + '/' + err.config?.url)}</a> </>
    const data: any = err.response?.data;
    let adicionalProps : NotificationArgsProps = {} as NotificationArgsProps;

    const mensagem = ((): ReactNode => {
        if (data != null) {
            if (new WebHttpErroResponseValidacaoEntity().isInstancia(data) && data as WebHttpErroResponseValidacaoEntity !== null) {
                const { mensagem: mensagemErro, data: infoValidacao } = data as WebHttpErroResponseValidacaoEntity;
                adicionalProps.duration = 0;

                return <>
                    {mensagemErro}
                    <List
                        dataSource={infoValidacao ?? []}
                        bordered
                        pagination={(infoValidacao?.length ?? 0) <= 4 ? undefined : { position : 'top', align : 'center', pageSize : 4, simple : true, hideOnSinglePage : true }}
                        renderItem={(item) => <List.Item><Typography.Text mark>{item.campo}</Typography.Text>: {item.mensagem}</List.Item>}
                    ></List>
                </>
            }
            else if (new WebHttpErroResponse().isInstancia(data)) {
                const { mensagem: mensagemErro } = data as WebHttpErroResponse;
                return mensagemErro;
            }
        }

        if (err.response?.status == 403) {
            return <>
                Acesso negado.<br />
                Você não tem permissões para acessar o recurso solicitado. <br />

                <br />
                <CaminhoDaRequisicao />
            </>
        }

        if (err.response?.status == 404) {
            return <>
                Caminho não encontrado.
                <br />
                <CaminhoDaRequisicao />
            </>
        }

        if (err.response?.status != 500 && err.response !== undefined) {
            return `Ocorreu um erro na requisição: "${err.response.data}"`;
        }

        return "Ocorreu um erro inesperado durante a requisição";
    })()

    notification.error({ 
        ...PropriedadesDeNotificacao.Erro(mensagem),
        ...adicionalProps
    });
}
